module.exports = __webpack_public_path__ + "img/logo.2262e88d.png";